import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const TheRadar: Site = {
  id: 'theradar',
  logo: 'svg/theradar.svg',
  label: 'The Radar',
  analyticsName: 'theradar',
  hostname: 'theradar.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
